import { API } from 'constants/apiEndPoints'
import { UserRedditPanelCSS } from './UserRedditPanelCSS.styled'
import { UserRedditOverview } from 'components/Molecules/userProfileOverview/UserRedditOverview'
import { useAPI } from 'utils/hooks/useAPI'
import { useEffect } from 'react'
import { ASYNC_STATUS_ID } from 'constants/index'

export const UserRedditPanel = (props) => {
  //insert useAPI
  const [unlinkSate, sendUnlinkQuery, hasUnlinkState] = useAPI(
    API.ACCOUNT_REDDIT_UNLINK,
    {
      controlled: true,
      withJwt: true,
    }
  )

  useEffect(() => {
    if (hasUnlinkState(ASYNC_STATUS_ID.CONFIRMED)) props.refreshData()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unlinkSate.status?.id, unlinkSate?.data])

  const unlinkReddit = () => {
    sendUnlinkQuery()
  }
  return (
    <UserRedditPanelCSS>
      <div className='sections_wrapper'>
        <div className='user_tabs_panel' id='user-overview_panel-reddit'>
          <UserRedditOverview {...props} />
          <div className='content column wide linked_to_reddit'>
            <div className='subtitle'>Linked to Reddit</div>
            <button className='unlink_reddit_account' onClick={unlinkReddit}>
              Unlink Reddit account
            </button>
          </div>
        </div>
      </div>
    </UserRedditPanelCSS>
  )
}
